interface PaymentSectionProps {
  description: string;
}

const PaymentSection = ({ description }: PaymentSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Complete Your Registration</h3>
      <p>
        {description}
      </p>
    </div>
  );
};

export default PaymentSection;
